export default __webpack_public_path__ + "static/media/cars.66f63fdb.png";